"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const OsmosysResourcePage_1 = require("../../../comps/reusables/OsmosysResourcePage");
const Router_1 = require("./Router");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
// interface IProps {}
exports.AdsDetail = () => {
    const { match: { params }, } = use_react_router_1.default();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reusables_1.OsmosysResourcePage, { query: graphql_1.ad, paths: { item: 'ad' }, getNav: () => {
                return [
                    {
                        name: 'Settings',
                        to: `/ads/${params.id}/settings`,
                    },
                    {
                        adminRole: 'app',
                        name: 'Emails',
                        to: `/ads/${params.id}/emails`,
                    },
                ];
            }, variables: {
                id: params && params.id,
            }, getTitle: data => {
                return data && data.ad && data.ad.name;
            }, getSubTitle: () => {
                return 'Ad';
            } },
            react_1.default.createElement(OsmosysResourcePage_1.OsmosysResourcePageInner, null, data => {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Router_1.AdsDetailRouter, { data: data.ad })));
            }))));
};
exports.default = exports.AdsDetail;
//# sourceMappingURL=index.js.map